<template>
  <el-drawer :title="payStatus === 9 ? '作废记录' : '详情'" :visible.sync="drawer" destroy-on-close :wrapperClosable="false" :custom-class="sidebarIsOpen ? 'width210' : 'width54'" :modal-append-to-body="false"
    append-to-body>
    <el-descriptions class="mx-20-1 bg-#fff pt-40 pr-30" title="缴费记录" :column="3">
      <el-descriptions-item label="项目名称">
        {{ getCommunityName(previewForm.communityId) }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="mx-20-4 bg-#fff pr-30">
      <el-table :data="[previewForm]" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }" style="margin-bottom: 24px">
        <el-table-column label="流水单号" align="center">
          <template slot-scope="scope">
            {{ scope.row.paymentSn || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="应收金额" align="center">
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.orderAmount) }}</template>
        </el-table-column>
        <el-table-column label="优惠金额" align="center">
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.preferentialAmount) }}</template>
        </el-table-column>
        <el-table-column label="收款金额" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.subPayAmount">{{ dictType('payWay', scope.row.payWayId) }}：</span>
              {{ keepTwoDecimal(scope.row.payAmount) }}
            </div>
            <div v-if="scope.row.subPayAmount">{{ dictType('payWay', scope.row.subPayWayId) }}：{{ keepTwoDecimal(scope.row.subPayAmount) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="退款金额" align="center">
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.returnAmount) }}</template>
        </el-table-column>
      </el-table>
    </div>
    <el-descriptions class="mx-20-1 bg-#fff pr-30" :column="3">
      <el-descriptions-item v-if="previewForm.payerUserName" label="付款人">
        {{ previewForm.payerUserName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item v-if="previewForm.payeeStaffName" label="收款人">
        {{ previewForm.payeeStaffName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="支付方式">
        {{ dictType('payWay', previewForm.payWayId) }}
        <span v-if="previewForm.subPayAmount">、{{ dictType('payWay', previewForm.subPayWayId) }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="收款时间">
        {{ previewForm.payTime || '-' }}
      </el-descriptions-item>
      <el-descriptions-item v-if="previewForm.wechatPaymentNo" label="微信流水号">
        {{ previewForm.wechatPaymentNo || '-' }}
      </el-descriptions-item>
      <template v-if="previewForm.invoiceState === 1">
        <el-descriptions-item label="开票状态">
          {{ dictType('invoiceStateArr', previewForm.invoiceState) }}
        </el-descriptions-item>
        <el-descriptions-item v-if="previewForm.invoiceStaffName" label="开票人">
          {{ previewForm.invoiceStaffName || '-' }}
        </el-descriptions-item>
        <el-descriptions-item v-if="previewForm.invoiceTime" label="开票时间">
          {{ previewForm.invoiceTime || '-' }}
        </el-descriptions-item>
      </template>
    </el-descriptions>
    <el-descriptions class="mx-20-1 bg-#fff pr-30" :column="1">
      <el-descriptions-item v-if="previewForm.remark" label="备注">
        {{ previewForm.remark || '-' }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="mx-20-4 bg-#fff pr-30">
      <div class="form-Title mx-20-2" style="display: flex; justify-content: space-between">缴费明细</div>
      <el-table :data="orderList" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column label="流水单号" align="center" width="200">
          <template slot-scope="scope">
            {{ scope.row.paymentSn || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="费用单号" align="center" width="200">
          <template slot-scope="scope">
            {{ scope.row.orderSn || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="房屋/车位/车辆" align="left" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.buildingRoomCode" class="flex-start">
              <span class="sign flex-center house">房屋</span>
              <span>{{ scope.row.buildingRoomCode }}</span>
            </div>
            <div v-if="scope.row.parkingSpaceName" class="flex-start">
              <span class="sign flex-center parking">车位</span>
              <span>{{ scope.row.parkingSpaceName }}</span>
            </div>
            <div v-if="scope.row.parkingCarCode" class="flex-start">
              <span class="sign flex-center car">车辆</span>
              <span>{{ scope.row.parkingCarCode }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收费科目" align="center" min-width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.itemName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="计费时间" align="center" width="200">
          <template slot-scope="scope">
            {{ handlerDate(scope.row.chargeBeginDate, scope.row.chargeEndDate) }}
          </template>
        </el-table-column>
        <el-table-column label="计费标准" align="center" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.chargeCriterionDesc">{{ scope.row.chargeCriterionDesc }}</span>
            <span v-else-if="scope.row.feeDescription">{{ scope.row.feeDescription }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="应收金额" align="center" width="120">
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.orderAmount) }}</template>
        </el-table-column>
        <el-table-column label="优惠金额" align="center" width="120">
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.preferentialAmount) }}</template>
        </el-table-column>
        <el-table-column label="违约金" align="center" width="120">
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.payPenaltyAmount) }}</template>
        </el-table-column>
        <el-table-column align="center" width="120">
          <template slot="header" slot-scope="scope">
            <el-popover placement="bottom" trigger="hover">
              <div slot="reference">
                <span>收款金额</span>
                <img src="@/assets/image/report_tips_icon.png" alt="" style="vertical-align: text-bottom; width: 16px; height: 16px; margin-left: 8px" />
              </div>
              <div>应收金额-优惠金额+违约金</div>
            </el-popover>
          </template>
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.payAmount) }}</template>
        </el-table-column>
        <el-table-column label="退款金额" align="center" width="120">
          <template slot-scope="scope">
            <span v-if="Number(scope.row.returnAmount || 0) !== 0" class="returnAmount" @click="checkReturnRecord(scope.row)">
              {{ keepTwoDecimal(scope.row.returnAmount) }}
            </span>
            <span v-else>{{ keepTwoDecimal(scope.row.returnAmount) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收款时间" align="center" width="180">
          <template slot-scope="scope">
            {{ scope.row.payTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column v-if="payStatus !== 9" prop="address" label="操作" fixed="right" align="center" width="100">
          <template slot-scope="scope">
            <el-link type="primary" @click="preview(scope.row.id)">详情</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-descriptions v-if="payStatus === 9" class="pt-20 bg-#fff" :column="3">
        <el-descriptions-item label="作废操作人">
          {{ previewForm.voidCheckStaffName || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="作废原因">
          {{ previewForm.voidCheckReason || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="作废时间">
          {{ previewForm.voidCheckTime || '-' }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <BillDetail ref="BillDetail" />
  </el-drawer>
</template>

<script>
import BillDetail from './BillDetail.vue'
export default {
  inject: ['indexThis'],
  components: { BillDetail },
  data() {
    return {
      drawer: false,
      previewForm: {},
      orderList: [],
      payStatus: '',
    }
  },
  methods: {
    preview(id) {
      this.$refs.BillDetail.orderItemList({
        communityId: this.previewForm.communityId,
        id,
      })
      this.$refs.BillDetail.drawer = true
    },
  },
}
</script>

<style scoped lang="scss">
.report-tips-icon {
  width: 16px;
  height: 16px;
  margin-left: 8px;
  vertical-align: text-bottom;
}
.sign {
  width: 28px;
  height: 18px;
  border-radius: 4px;
  margin-right: 8px;
  font-size: 10px;
  color: #fff;
}
.house {
  background: #00b42a;
}
.parking {
  background: #31a8ff;
}

.car {
  background: #31d2ff;
}
</style>
